// Apenas a exibição é transformada: o texto original continua intacto para envio e armazenamento.
const URL_IN_TEXT = /https?:\/\/[^\s<>"'`]+/gi;

function linkEnd(value) {
  let end = value.length;
  while (end) {
    const last = value[end - 1];
    if (/[.,!?;:]/.test(last)) { end--; continue; }
    const opening = { ")":"(", "]":"[", "}":"{" }[last];
    if (opening) {
      const part = value.slice(0, end);
      if (part.split(last).length > part.split(opening).length) { end--; continue; }
    }
    break;
  }
  return end;
}

export default function MessageTextLinks({ text }) {
  if (typeof text !== "string") return text ?? null;
  const parts = [];
  let offset = 0;
  for (const match of text.matchAll(URL_IN_TEXT)) {
    const start = match.index;
    // Não transformar um protocolo embutido em outra palavra/esquema.
    if (start && /[\w.+:/-]/.test(text[start - 1])) continue;
    const url = match[0].slice(0, linkEnd(match[0]));
    try {
      const parsed = new URL(url);
      if (!["http:", "https:"].includes(parsed.protocol) || !parsed.hostname) continue;
    } catch { continue; }
    parts.push(text.slice(offset, start));
    parts.push(<a key={start} href={url} target="_blank" rel="noopener noreferrer"
      style={{ color:"inherit", textDecoration:"underline", overflowWrap:"anywhere" }}>{url}</a>);
    offset = start + url.length;
  }
  parts.push(text.slice(offset));
  return <>{parts}</>;
}